import React, {FunctionComponent, useCallback} from "react";
import { ScaleExercise } from '../../models/scale-exercise';
import Checkbox from "../../components/forms/checkbox";

interface HandTogglesProps {
  setShowLeftHand: (val: boolean) => any;
  setShowRightHand: (val: boolean) => any;
  showLeftHand: boolean;
  showRightHand: boolean;
}

const HandToggles: FunctionComponent<HandTogglesProps> = ({showLeftHand, showRightHand, setShowLeftHand, setShowRightHand}) => {
  return (
    <div className='flex my-4'>
      <div className='flex-1'>
        <Checkbox
          checked={showLeftHand}
          className='px-2'
          inline={true}
          name='lefthand'
          onChange={e => setShowLeftHand(e.target.checked)}
          label='Show left hand'
        />
      </div>

      <div className='flex-1'>
        <Checkbox
          checked={showRightHand}
          className='px-2'
          inline={true}
          name='righthand'
          onChange={e => setShowRightHand(e.target.checked)}
          label='Show right hand'
        />
      </div>

      <div className='flex-1'></div>
    </div>
  );
}

export default HandToggles;
